module.exports = __webpack_public_path__ + "assets/img/explain_bg.7cfcf9de.png";